import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { VideoInfoModalParams } from './video-info-modal.service';

@Component({
  selector: 'app-video-info-modal',
  templateUrl: './video-info-modal.component.html',
  styleUrls: ['./video-info-modal.component.scss']
})
export class VideoInfoModalComponent implements OnInit {

  public videoUrl: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: VideoInfoModalParams,
    private readonly domSanitizer: DomSanitizer,
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
  ngOnInit(): void {
    this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.data.videoId}?modestbranding=1&rel=0`) as string;
  }

}
